import React from "react";
import eamilIcon from "../images/email.webp";
import phoneIcon from "../images/phone.webp";
import locationIcon from "../images/location.webp";
import productIcon from "../images/productIcon.webp";
const Footer = () => {
  return (
    <div>
      <div className="footerBoxMain">
        <div className="footerBox">
          <div className="footerFormBox">
            <div className="emailPhoneInfo">
              <div className="footerInputBox emailCol">
                <p className="footerLocationIcon">
                  <img src={eamilIcon} alt="" width="33" height="25" />
                </p>
                <div>
                  <p className="footerEmailTitle">Mail to Us At</p>
                  <a className="footerEmail" href='mailto:"info@doclift.ai"'>
                    info@doclift.ai
                  </a>
                </div>
              </div>
              <div className="footerInputBox emailCol">
                <p className="footerLocationIcon">
                  <img
                    src={productIcon}
                    alt=""
                    height="25"
                    style={{ height: "auto" }}
                  />
                </p>
                <div>
                  <p className="footerEmailTitle">Product of</p>
                  <a
                    className="footerEmail"
                    href="https://orryworx.com/"
                    target="_blank"
                  >
                    www.orrworx.com
                  </a>
                </div>
              </div>
              {/* <div className="footerInputBox phonCol">
                <p className="footerLocationIcon">
                  <img
                    title="call icon"
                    src={phoneIcon}
                    alt=""
                    width="51"
                    height="47"
                  />
                </p>
                <div>
                  <p className="footerPhoneTitle">Phone Number</p>
                  <a className="footerPhone" href="tel:91 (991) 110 8696">
                    +91 (991) 110 8696
                  </a>
                </div>
              </div> */}
            </div>
            <div className="footerInputBox addressCol">
              <p className="footerLocationIcon">
                <img
                  title="Location icon"
                  src={locationIcon}
                  alt=""
                  width="51"
                  height="51"
                />
              </p>
              <div>
                <p className="footerLocationTitle">USA</p>
                <p className="footerLocation">
                  PO BOX 3591, ATTLEBORO MA, 02703
                </p>
                <p className="footerLocationTitle mt-[10px]">Gurugram</p>
                <p className="footerLocation">
                  Plot No. 1038, Sector 40 Gurugram (HR), 122001
                </p>
              </div>
            </div>
            <div className="socialMediaLink">
              {/* <p className="footerSocalMediaTitle">Lets Connect</p>
              <div className="footerSocalMediaIcon">
                <a
                  href="https://www.facebook.com/orryworx/"
                  target="_blank"
                  rel="noopener"
                >
                  {" "}
                </a>
                <a
                  href="https://www.linkedin.com/company/orryworx/about/?viewAsMember=false"
                  target="_blank"
                  rel="noopener"
                >
                  {" "}
                </a>
              </div> */}
            </div>
          </div>
          <div className="subFooterBox">
            <p>© 2024 Doclift | All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
